/**
 * Wealthica Data Persistence Hook (Multi-store only)
 *
 * Under the accelerated cutover, persistence is orchestrated by the multi-store actions.
 * This hook remains for API compatibility but does not execute persistence logic.
 */

import { useEffect, useRef } from 'react';

interface UseWealthicaPersistenceProps {
  persistDataPreference: boolean;
  connectionData: any;
  wealthicaAccounts: any[] | null;
  accountsWithPositions: any[] | null;
  isLoadingPositions: boolean;
}

export function useWealthicaPersistence({
  persistDataPreference,
  connectionData,
  wealthicaAccounts,
  accountsWithPositions,
  isLoadingPositions
}: UseWealthicaPersistenceProps) {
  // Multi-store: persistence handled by store actions; this hook intentionally no-ops
  const lastSignatureRef = useRef<string>('');
  const persistenceTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  // Keep a minimal effect for API stability and future extension points
  useEffect(() => {
    // intentionally empty
    return () => {
      if (persistenceTimeoutRef.current) {
        clearTimeout(persistenceTimeoutRef.current);
      }
    };
  }, [persistDataPreference, wealthicaAccounts?.length, accountsWithPositions?.length, isLoadingPositions]);

  return {
    lastSignatureRef,
    persistenceTimeoutRef
  };
}
